import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

// store
import { useNetworkStore } from '@/store';

// hooks
import { useWeb3React as useWeb3ReactCore } from '@web3-react/core';

// constants
import connectors from 'constants/connectors';

const { injected } = connectors(`Ethereum`);

export const connectorLocalStorageKey = `connetorId`;

function useEagerConnect() {
  const { activate, active } = useWeb3ReactCore(); // specifically using useWeb3ReactCore because of what this hook does
  const [tried, setTried] = useState(false);
  // eslint-disable-next-line no-shadow
  const setNetwork = useNetworkStore(({ setNetwork }) => setNetwork);

  useEffect(() => {
    injected.isAuthorized().then((isAuthorized: boolean) => {
      const hasSignedIn = window.localStorage.getItem(connectorLocalStorageKey);

      if (isAuthorized && hasSignedIn) {
        activate(injected, undefined, true)
          .then(() => {
            setNetwork(`Ethereum`);
          })
          .catch(() => {
            setTried(true);
          });
      } else if (isMobile && window.ethereum && hasSignedIn) {
        activate(injected, undefined, true).catch(() => {
          setNetwork(`Ethereum`);
          setTried(true);
        });
      } else {
        setTried(true);
      }
    });
  }, [activate]); // intentionally only running on mount (make sure it's only mounted once :))

  // if the connection worked, wait until we get confirmation of that to flip the flag
  useEffect(() => {
    if (active) {
      setTried(true);
    }
  }, [active]);

  return tried;
}

export default useEagerConnect;
